/**
 * @desc 财务收支应用表查询详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.FinanceAccountResponseDto>;
export function request(appName: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/financeAccount/details/${appName}`, {
      method: "GET",

      ...options,
    }),
  );
}
